import { render, staticRenderFns } from "./link_error.vue?vue&type=template&id=35b2425e&scoped=true&"
import script from "./link_error.vue?vue&type=script&lang=js&"
export * from "./link_error.vue?vue&type=script&lang=js&"
import style0 from "./link_error.vue?vue&type=style&index=0&id=35b2425e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2425e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
